import DOMPurify from 'dompurify'
import linkifyHtml from 'linkify-html'

const linkifyOptions = {
  validate: (value: string, type: string) => {
    // メールアドレスが mailto: リンクへ変換されるのを防ぐため url のみ許可
    if (type !== 'url') {
      return false
    }
    return /^https?:\/\//.test(value)
  },
}

const dompurifyConfig = {
  ADD_ATTR: ['target'],
}

DOMPurify.addHook('afterSanitizeAttributes', (node: Element) => {
  if (node.tagName === 'A') {
    node.setAttribute('target', '_blank')
    node.setAttribute('rel', 'noopener noreferrer')
  }
})

/**
 * HTMLを表示可能な形式に変換する。
 * @param {string} html - 変換するHTML文字列
 * @returns {string} 変換後のHTML文字列
 */
export const prepareHtmlForDisplay = (html: string): string => {
  if (!html) {
    return ''
  }

  const withLineBreaks = html.replace(/\r\n|\n/g, '<br/>')
  const linkified = linkifyHtml(withLineBreaks, linkifyOptions)
  return DOMPurify.sanitize(linkified, dompurifyConfig)
}
